import { defineComponent, h } from 'vue';
import { vueCreateAppInit } from '@/utils/js/initVariable';
import SvgIcon from '@/components/SvgIcon';

const FileUploadMarkerComponent = defineComponent({
  setup() {
    return () => h('div', {
      style: {
        width: '24px',
        height: '24px',
        background: '#51b1d9',
        border: '2px solid white',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
      }
    }, [
      h(SvgIcon, {
        iconName: 'file-upload',
        style: {
          width: '14px',
          height: '14px',
          fill: 'white',
          color: 'white',
          '--fillColor': 'white'
        }
      })
    ]);
  }
});

/**
 * 获取文件上传的专用地图 Icon
 * 此方法使用 Vue 组件来渲染 Icon 内容，替代硬编码的 HTML 字符串
 * 注意：由于 Leaflet icon 的生命周期限制，如果应用内会创建成百上千个 marker，使用字符串形式性能更佳；
 * 但如果只是局部使用，此方式代码更优雅且易于维护。
 */
export const getFileUploadIcon = (options = {}) => {
  const div = document.createElement('div');
  const app = vueCreateAppInit(FileUploadMarkerComponent);
  app.mount(div);

  const icon = L.divIcon({
    html: div,
    className: '',
    iconSize: [24, 24],
    iconAnchor: [12, 0],
    ...options
  });

  // 记录挂载的实例，方便外部随 marker 销毁时清理
  icon._vueApp = app;
  
  return icon;
};
